import React, { useRef, useEffect, memo } from 'react';
import './PortfolioGallery.css';

const images = [
  { src: '/assets/HallOfArt/180.png',  id: '01' },
  { src: '/assets/HallOfArt/177.png',  id: '02' },
  { src: '/assets/HallOfArt/176.JPG',  id: '03' },
  { src: '/assets/HallOfArt/162.png',  id: '04' },
  { src: '/assets/HallOfArt/159.png',  id: '05' },
  { src: '/assets/HallOfArt/157.png',  id: '06' },
  { src: '/assets/HallOfArt/155.png',  id: '07' },
  { src: '/assets/HallOfArt/154.png',  id: '08' },
  { src: '/assets/HallOfArt/150.png',  id: '09' },
  { src: '/assets/HallOfArt/147.jpg',  id: '10' },
  { src: '/assets/HallOfArt/146.png',  id: '11' },
  { src: '/assets/HallOfArt/136.png',  id: '12' },
  { src: '/assets/HallOfArt/132.png',  id: '13' },
  { src: '/assets/HallOfArt/120.jpg',  id: '14' },
  { src: '/assets/HallOfArt/117.jpg',  id: '15' },
  { src: '/assets/HallOfArt/115.jpg',  id: '16' },
  { src: '/assets/HallOfArt/113.png',  id: '17' },
];

/* ── Single gallery item with 3D tilt ── */
const GalleryItem = memo(({ src, id }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width  - 0.5);
    const y = ((e.clientY - r.top)  / r.height - 0.5);
    el.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
    el.style.setProperty('--ry', `${(x  * 10).toFixed(2)}deg`);
  };
  const onLeave = () => {
    const el = ref.current;
    if (el) { el.style.setProperty('--rx','0deg'); el.style.setProperty('--ry','0deg'); }
  };

  return (
    <div ref={ref} className="gi" onMouseMove={onMove} onMouseLeave={onLeave}>
      <div className="gi-inner">
        <img src={src} alt={`Artwork ${id}`} loading="lazy" draggable="false" />
        <div className="gi-overlay">
          <span className="gi-num">{id}</span>
          <span className="gi-view">View →</span>
        </div>
      </div>
    </div>
  );
});

/* ── Grid ── */
export default function PortfolioGallery() {
  const gridRef = useRef(null);

  useEffect(() => {
    const items = gridRef.current?.querySelectorAll('.gi');
    if (!items) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gi--visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    items.forEach((item, i) => {
      item.style.transitionDelay = `${(i % 6) * 0.07}s`;
      obs.observe(item);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="portfolio-gallery" ref={gridRef}>
      {images.map((img) => <GalleryItem key={img.id} src={img.src} id={img.id} />)}
    </div>
  );
}
